import { render, staticRenderFns } from "./PageEventLevelDetail.vue?vue&type=template&id=5e80bf96&scoped=true&"
import script from "./PageEventLevelDetail.vue?vue&type=script&lang=js&"
export * from "./PageEventLevelDetail.vue?vue&type=script&lang=js&"
import style0 from "./PageEventLevelDetail.vue?vue&type=style&index=0&id=5e80bf96&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e80bf96",
  null
  
)

export default component.exports